import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";
import { VoucherType } from "../model/GetVoucherTypeSuccessResponse";

const emptyVoucherTypeList: VoucherType[] = [];
Object.freeze(emptyVoucherTypeList);

export const voucherTypeList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.voucherTypeList || emptyVoucherTypeList;
};

export const isLoadingVoucherTypeList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.voucherTypeListIsLoading || false;
};

export const voucherType = (
  state: RootState,
  id: string | undefined,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.voucherType?.[id];
};

export const isLoadingVoucherType = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return false;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.voucherTypeIsLoading[id];
};

export const upsertVoucherTypeErrors = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.upsertVoucherTypeErrors[id || "__new"];
};
